



























import CustomStatCard from '@/components/Reusable/CustomStatCardMain.vue';
import CustomStatCardChart from '@/components/Reusable/CustomStatCardChart.vue';
import { dailyStat, StatParams } from '@/store/interfaces/stats';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'MonitorHomeTransactions',
  components: {
    CustomStatCard,
    CustomStatCardChart,
  },
  props: {
    stats: {
      type: Object as PropType<StatParams>,
      required: true,
    },
  },
  data: () => ({
    dailyStat: [
      {
        title: 'Diario',
        total: 'total_today',
        labels: [
          {
            title: 'Exitosas',
            total: 'total_today_success',
            icon: 'fas fa-caret-square-up',
            class: 'text-success',
          },
          {
            title: 'Fallidas',
            total: 'total_today_failure',
            icon: 'fas fa-caret-square-down',
            class: 'text-warning',
          },
          {
            title: 'Con riesgo',
            total: 'total_today_with_risk',
            icon: 'fas fa-temperature-high',
            class: 'text-danger',
          }
        ],
      },
      {
        title: 'Semanal',
        total: 'total_last_week',
        labels: [
          {
            title: 'Exitosas',
            total: 'total_last_week_success',
            icon: 'fas fa-caret-square-up',
            class: 'text-success',
          },
          {
            title: 'Fallidas',
            total: 'total_last_week_failure',
            icon: 'fas fa-caret-square-down',
            class: 'text-warning',
          },
          {
            title: 'Con riesgo',
            total: 'total_last_week_with_risk',
            icon: 'fas fa-temperature-high',
            class: 'text-danger',
          }
        ],
      },
      {
        title: 'Mensual',
        total: 'total_last_month',
        labels: [
          {
            title: 'Exitosas',
            total: 'total_last_month_success',
            icon: 'fas fa-caret-square-up',
            class: 'text-success',
          },
          {
            title: 'Fallidas',
            total: 'total_last_month_failure',
            icon: 'fas fa-caret-square-down',
            class: 'text-warning',
          },
          {
            title: 'Con riesgo',
            total: 'total_last_month_with_risk',
            icon: 'fas fa-temperature-high',
            class: 'text-danger',
          }
        ],
      }
    ] as dailyStat[],
    transactionsTickets: [
      {
        title: 'transacciones procesadas',
        total: 'total',
        values: [
          {
            title: 'Exitosas',
            total: 'total_success',
            icon: 'fas fa-caret-square-up',
            class: 'text-success',
          },
          {
            title: 'Fallidas',
            total: 'total_failure',
            icon: 'fas fa-caret-square-down',
            class: 'text-warning',
          },
          {
            title: 'Con Riesgo',
            total: 'total_with_risk',
            icon: 'fas fa-temperature-high',
            class: 'text-danger',
          }
        ],
      },
      {
        title: 'Transacciones con riesgo',
        total: 'total_with_risk',
        values: [
          {
            title: 'Bajo',
            total: 'total_with_risk_low',
            icon: 'fas fa-temperature-low',
            class: 'text-green',
          },
          {
            title: 'Medio',
            total: 'total_with_risk_moderate',
            icon: 'fas fa-thermometer-half',
            class: 'text-warning',
          },
          {
            title: 'Alto',
            total: 'total_with_risk_high',
            icon: 'fas fa-temperature-high',
            class: 'text-danger',
          }
        ],
      }
    ],
  }),
});

